import { Injectable, computed, inject, signal } from '@angular/core';
// import { AmplifyUser, CognitoAttributes } from '@aws-amplify/ui';
import { AuthUser } from 'aws-amplify/auth';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { updatePassword, fetchUserAttributes } from 'aws-amplify/auth';
import { OrganizationsService } from './organizations.service';

interface CognitoAttributes {
  email?: string;
  email_verified?: string;
  family_name?: string;
  given_name?: string;
  phone_number?: string;
  phone_number_verified?: string;
  preferred_username?: string;
  sub?: string;
  [key: string]: string | undefined;
}

interface AmplifyUser extends AuthUser {
  attributes: CognitoAttributes;
}

@Injectable({
  providedIn: 'root',
})
export class AmplifyService {
  public signedIn(signedIn: boolean): void {
    this.isSignedInSignal.set(signedIn);
  }

  public signOut(): void {
    this.authenticatorService.signOut();
  }

  public loggedInUser(user: AuthUser): void {
    fetchUserAttributes().then((attributes) => {
      const userAttributes = { ...attributes };
      const amplifyUser = { ...user, attributes: userAttributes };

      this.currentUserSignal.set(amplifyUser);
    });
  }

  public async changePassword(oldPassword: string, newPassword: string): Promise<void> {
    await updatePassword({ oldPassword, newPassword });
  }

  public attributeValue(name: string): string {
    if (this.currentUser() !== null ?? this.currentUser()?.attributes) {
      return this.currentUser()?.attributes[name] as string;
    }

    return '';
  }

  private fullName(userAttributes?: any): string {
    if (!userAttributes) {
      return '';
    } else {
      return `${userAttributes['given_name']} ${userAttributes['family_name']}`;
    }
  }

  private readonly authenticatorService = inject(AuthenticatorService);
  private readonly organizationsService = inject(OrganizationsService);
  private readonly isSignedInSignal = signal<boolean>(false);
  private readonly currentUserSignal = signal<AmplifyUser | null>(null);

  public isSignedIn = this.isSignedInSignal.asReadonly();
  public currentUser = this.currentUserSignal.asReadonly();
  public currentUserFullName = computed(() => {
    if (this.currentUser()) {
      const user = this.currentUser();

      return this.fullName(user?.attributes);
    } else {
      return '';
    }
  });
}
